import httpService from "../../utils/httpService"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { AppThunk } from "../../rootReducer"
import { getAccessToken } from "../../utils/common"

export interface AppRolePermission {
    role: string;
    operation: Operation[];
}

export interface Operation {
    section: string;
    description: string;
    add: boolean | null;
    edit: boolean | null;
    delete: boolean | null;
}
type AccessPoliciesState = {
    loading: boolean
    permissions: AppRolePermission[]
}
const initialState: AccessPoliciesState = {
    permissions: [],
    loading: false,
}
const accessPoliciesSlice = createSlice({
    name: "accessPolicies",
    initialState,
    reducers: {
        showLoader(state, action: PayloadAction<boolean>) {
            state.loading = action.payload
        },
        setAccessPolices(state, action: PayloadAction<AppRolePermission[]>) {
            state.permissions = action.payload
        },
    },
})

export const { showLoader, setAccessPolices } = accessPoliciesSlice.actions
export default accessPoliciesSlice.reducer

//axles
export const getAccessPolicies = (): AppThunk => (dispatch: any, getState) => {
    dispatch(showLoader(true))
    httpService(getAccessToken(getState()))
        .get(`users/accesspolicies`)
        .then(res => {
            dispatch(showLoader(false))
            dispatch(setAccessPolices(res.data))
        })
        .catch(error => {
            dispatch(showLoader(false))
        })
}